import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
@Injectable()
export class CustomerService {

  constructor(private http:HttpClient) { }

  public getCompetitors(customerId:string){
    const url=`${environment.onlineCompetitors}`;
    const params:HttpParams= new HttpParams()
      .set("customer_id",customerId);
    return this.http.get(url, {params: params})
      .pipe(
        map(response=>response)
      );
  }
}
